import { render, staticRenderFns } from "./updateDiscounts.vue?vue&type=template&id=21f039a3&"
import script from "./updateDiscounts.vue?vue&type=script&lang=js&"
export * from "./updateDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./updateDiscounts.vue?vue&type=style&index=0&id=21f039a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports